<template>
  <div id="patient-dose-spot-active-medications-v1-slxs8w" class="fb-patient-dose-spot-active-medications-v1">
    <div id="patient-dose-spot-active-medications-v1-jwwirf" v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group id="patient-dose-spot-active-medications-v1-b8uckn"
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table id="patient-dose-spot-active-medications-v1-l6blt9"
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div id="patient-dose-spot-active-medications-v1-yi4n38" v-else-if="showType == 'properties'">
      <patient-dose-spot-active-medications-v1-properties id="patient-dose-spot-active-medications-v1-oh66e7" :formId="formId" />
    </div>
    <div id="patient-dose-spot-active-medications-v1-pd302e"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      class="medication-table-container"
      v-show="!computedHidden"
    >
      <b-form-group id="patient-dose-spot-active-medications-v1-l8gqjt"
        :description="computedPropertiesForm.description"
        :style="properties.style"
      >
        <template v-slot:label="">
          <div id="patient-dose-spot-active-medications-v1-n2r2ft" class="d-flex align-items-center justify-content-between">
            <span id="patient-dose-spot-active-medications-v1-to4v3l" style="font-size: 16px" class="mr-3">
              {{
                computedPropertiesForm.label
              }}
            </span>
            <b-button id="patient-dose-spot-active-medications-v1-abw11u" @click="fetchMedications" variant="primary" class="mr-2"
              ><i id="patient-dose-spot-active-medications-v1-u97567" class="fa fa-sync-alt mr-2"></i> Reload Active
              Medications</b-button
            >
          </div>
        </template>
        <b-table id="patient-dose-spot-active-medications-v1-0uvbfx"
          class="custom-fb-table"
          responsive
          striped
          hover
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        >
          <template #cell(medication)="data">
              <div>
               {{ data.item.medication }}<br>
               Effective Date: {{ data.item.effectiveDate }}<br>
               Sig: {{ data.item.sig }}
              </div>
          </template>

        </b-table>
        <div id="patient-dose-spot-active-medications-v1-v7oax1" v-if="doseSpotErrorMessage" class="text-danger text-center">
          {{ doseSpotErrorMessage }}
        </div>
      </b-form-group>
    </div>
    <div id="patient-dose-spot-active-medications-v1-3uumpn"
      v-if="showType == 'form-viewer' || showType == 'e-form'"
      :style="properties.style"
      class="medication-table-container"
    >
      <b-form-group id="patient-dose-spot-active-medications-v1-kre65i"
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table id="patient-dose-spot-active-medications-v1-ql6qzn"
            responsive
            :items="tableProperties.items"
            :fields="tableProperties.columns"
          ></b-table>
        <div id="patient-dose-spot-active-medications-v1-ya6eel" v-if="doseSpotErrorMessage" class="text-danger text-center">{{doseSpotErrorMessage}}</div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PatientDoseSpotActiveMedicationsV1Properties from "./PatientDoseSpotActiveMedicationsV1Properties.vue";
import doseSpotServer from "../../../../server/doseSpot";

export default {
  name: "PatientDoseSpotActiveMedicationsV1",
  components: { PatientDoseSpotActiveMedicationsV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      doseSpotErrorMessage: null,
      medications: [],
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
    };
  },
  async mounted() {
    if (this.showType != "form-builder") {
      if (
        this.getFormSubmitterComponentValue(this.id) &&
        (this.showType == "form-submitter" || this.showType == "e-form")
      ) {
        const value = this.getFormSubmitterComponentValue(this.id);
        this.medications = value.medications;
        this.doseSpotErrorMessage = value.error;
      } else if (
        this.showType == "form-submitter" ||
        this.showType == "e-form"
      ) {
        this.fetchMedications();
      }
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="8" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50" style="width: 100%; font-size: 11px; table-layout: fixed;">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                        <th role="columnheader" scope="col" aria-colindex="1" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                          <div>Medication</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="2" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                          <div>Dispense</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="4" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                           <div>Date Written</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="5" class="" style="width: 10%; max-width: 10%; font-size: 12px; padding: 2px 3px;">
                          <div>Substitution Allowed</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="6" class="" style="width: 19%; max-width: 19%; font-size: 12px; padding: 2px 3px;">
                          <div>Day Supply</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="7" class="" style="width: 10% !important; max-width: 10% !important; min-width: 10% !important; font-size: 12px !important; padding: 2px 3px !important; overflow: visible !important; white-space: nowrap !important;">
                          <div>Number of Refills</div>
                        </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    (item) => `
                      <tr role="row" class="">
                      <td aria-colindex="1" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">
                        <div>
                          ${item.medication }<br>
                          Effective Date: ${item.effectiveDate }<br>
                          Sig: ${item.sig }
                        </div>
                      </td>
                      <td aria-colindex="7" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.dispense}</td>
                      <td aria-colindex="3" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.date}</td>
                      <td aria-colindex="4" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.substitutionAllowed}</td>
                      <td aria-colindex="5" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.daySupply}</td>
                      <td aria-colindex="8" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.numberOfRefills}</td>
                    </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    },
    fetchMedications() {
      if (this.showType == "form-submitter" || this.showType == "e-form") {
        doseSpotServer
          .query(this.client.id, { "Show-Alert-Error": false })
          .then((doseSpotList) => {
            this.doseSpotErrorMessage = null;
                         this.medications = doseSpotList.map((medication) => ({
               ...medication,
             }));
            this.setFormSubmitterComponentValue({
              controlId: this.id,
              controlValue: {
                medications: this.medications,
                error: this.doseSpotErrorMessage,
              },
              userAction: true,
              hardSet: true,
            });
          })
          .catch((error) => {
            this.medications = [];
            if (error.response.data.errorCode == "doseSpotDisabled") {
              this.doseSpotErrorMessage =
                "Your tenant doesn't have DoseSpot enabled. Please contact your administrator to get access.";
            }
            if (error.response.data.errorCode == "currentUserWithoutAccess") {
              this.doseSpotErrorMessage =
                "Your account doesn't have DoseSpot access. Please contact your administrator to get access.";
            }
            if (error.response.data.errorCode == "patientNotSynchronized") {
              this.doseSpotErrorMessage =
                "This patient has not been synced with DoseSpot. Please synchronize the patient before using this component.";
            }
            this.setFormSubmitterComponentValue({
              controlId: this.id,
              controlValue: {
                medications: this.medications,
                error: this.doseSpotErrorMessage,
              },
              userAction: true,
              hardSet: true,
            });
          });
      }
    },
    calculateDateRange(documentEffectiveDate, filterType, value = 0) {
      const endDate = new Date(documentEffectiveDate);
      endDate.setHours(23, 59, 59, 999);
      const startDate = new Date(documentEffectiveDate);

      switch (filterType) {
        case "days":
          startDate.setDate(startDate.getDate() - (value - 1));
          break;
        case "months":
          startDate.setMonth(startDate.getMonth() - (value - 1));
          break;
        case "current":
          break;
      }

      startDate.setHours(0, 0, 0, 0);
      return { startDate, endDate };
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage,
      document: (state) => state.form.document
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    tableProperties() {
      let items = this.medications;
      if(this.properties.dateFilter !== "all"){
        const documentEffectiveDate = this.document?.effectiveDate ? new Date(this.document.effectiveDate) : new Date();
        if(this.properties.dateFilter === "currentday"){
          const { startDate, endDate } = this.calculateDateRange(documentEffectiveDate, "current");
          items = items.filter(med => new Date(med.date) >= startDate && new Date(med.date) <= endDate);
        }
        else if(this.properties.dateFilter === "last7days"){
          const { startDate, endDate } = this.calculateDateRange(documentEffectiveDate, "days", 7);
          items = items.filter(med => new Date(med.date) >= startDate && new Date(med.date) <= endDate);
        }
        else if(this.properties.dateFilter === "last30days"){
          const { startDate, endDate } = this.calculateDateRange(documentEffectiveDate, "days", 30);
          items = items.filter(med => new Date(med.date) >= startDate && new Date(med.date) <= endDate);
        }
        else if(this.properties.dateFilter === "last3months"){
          const { startDate, endDate } = this.calculateDateRange(documentEffectiveDate, "months", 3);
          items = items.filter(med => new Date(med.date) >= startDate && new Date(med.date) <= endDate);
        }
      }
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "medication",
            label: "Medication",
          },
          {
            key: "dispense",
            label: "Dispense",
          },
          {
            key: "date",
            label: "Date Written",
          },
          {
            key: "substitutionAllowed",
            label: "Substitution Allowed",
          },
          {
            key: "daySupply",
            label: "Day Supply",
          },
          {
            key: "numberOfRefills",
            label: "Number of Refills",
          },
        ],
      };
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
  },
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
.custom-fb-table th,
.custom-fb-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.custom-fb-table td {
  font-size: 12px;
  padding-left: 17px;
}
.custom-fb-table th {
  font-size: 14px;
  padding-left: 17px;
}
</style>
